import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { UIEvent } from '../../UI/BaseUISystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function KeyCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);
    const sourceCard: BaseCard = system.getCardByID(taskData.cards[0]);
    sourceCard.getComponent(Renderable).visible = true;
    sourceCard.score = taskData.cardsScore[0];

    const keyAnimator = GameObject.Instantiate(Animator);
    keyAnimator.addChild(sourceCard);

    const targetCards: BaseCard[] = [];
    for (let i = 1; i < taskData.cards.length; i++) {
        const card: BaseCard = system.getCardByID(taskData.cards[i]);
        card.getComponent(Renderable).visible = true;
        card.score = taskData.cardsScore[i];
        keyAnimator.addChild(card);
        targetCards.push(card);
    }

    system.animator.addChild(keyAnimator);

    system.taskQueue.queue(
        new CardAnimationTask(taskData, system, 'CardKeyUnlock', keyAnimator, {
            sourceCard: sourceCard,
            targetCards: targetCards,
        })
    );
}
